// Module
var code = "<react-component name=\"CancelledBookingsReport\"></react-component>\n";
// Exports
module.exports = code;